export default (numerator, denominator, decimals = 2) => {
  const n = (numerator / denominator) * 100
  return parseFloat(n.toFixed(decimals)).toString()
}
